export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";